
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import AuthForm from './components/AuthForm'
import ProtectedRoute from './ProtectedRoute'
import DashboardLayout from './components/dashboard/DashboardLayout'
import PrivacyPolicy from './components/dashboard/PrivacyPolicy'
import TermsOfService from './components/dashboard/TermsOfService'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/" element={<AuthForm />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/:userId" element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}